const Logo = () => {
    return <div className="logo w-16 h-16 pt-2">
        <img src="https://i.etsystatic.com/8684670/r/il/0b8739/2383211648/il_570xN.2383211648_nz05.jpg" alt="" />
    </div>
}

export default Logo